export const SkipNextIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 4L8 9.66667L12 4L4 4ZM12 10.6667L4 10.6667L4 12L12 12L12 10.6667Z" />
  </svg>
);
